import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ContactLocation from './components/contact/ContactLocation';
import OurTeam from './components/team/Team';
import Partners from './components/partners/Partners';
import KindaKatch from './components/kindakatch/KindaKatch';

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />
  },
  {
    path: "/kinda-katch",
    element: <KindaKatch />
  },
  {
    path: "/contact-location",
    element: <ContactLocation />
  },
  {
    path: "/our-team",
    element: <OurTeam />
  },
  {
    path: "/our-partners",
    element: <Partners />
  }
])

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<RouterProvider router={router} />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
